export default __webpack_public_path__ + "static/BlackJack-f76285870b88bc5aed929b396a2b1e87.png";